// src/components/Admin/Auth/RegisterForm/RegisterForm.js
import React, { useState, useCallback } from "react";
import { Image, Form, Button, Dimmer, Loader } from "semantic-ui-react";
import { useFormik } from "formik";
import { Auth} from "../../../../api";
import { initialValues, validationSchema } from "./RegisterForm.Form";
import { toast, ToastContainer } from "react-toastify";
import { useDropzone } from "react-dropzone";
import { image } from "../../../../assets";
import "react-toastify/dist/ReactToastify.css";
import "./RegisterFormPartner.scss";
import { countries } from "../../../../contexts/countries";

const authController = new Auth();

export function RegisterFormPartner({ openLogin }) {

  const [verificationSent, setVerificationSent] = useState(false);
  const [pendingToken, setPendingToken] = useState(null);
  const [loading, setLoading] = useState(false);



  // 2) Registro por formulario
  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(verificationSent),
    validateOnChange: false,
    onSubmit: async () => {
      try {
        if (!verificationSent) {
          // Paso 1: envío de datos + avatar
          const formData = new FormData();
          formData.append("firstname", formik.values.firstname);
          formData.append("lastname", formik.values.lastname);
          formData.append("country", formik.values.country);
          formData.append("address", formik.values.address);
          formData.append("phone", formik.values.phone);
          formData.append("role", formik.values.role);
          formData.append("holded", formik.values.holded);
          formData.append("email", formik.values.email);
          formData.append("password", formik.values.password);
          if (formik.values.fileAvatar) {
            formData.append("avatar", formik.values.fileAvatar);
          }
          const response = await authController.register(formData);
          setPendingToken(response.pendingToken);
          setVerificationSent(true);
          toast.success("Código de verificación enviado a tu correo.");
        } else {
          // Paso 2: verificación de código
          const codeNumber = formik.values.code;
          const verificationResponse = await authController.verifyRegistration(
            pendingToken,
            codeNumber
          );
          authController.setAccessToken(verificationResponse.access);
          authController.setUserId(verificationResponse.user_id);
          toast.success("Usuario creado y verificado correctamente.");
          openLogin();
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: "top-center",
          autoClose: false,
          closeOnClick: true,
        });
      }
    },
  });

  // Dropzone para avatar
  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const validMimeTypes = ["image/jpeg", "image/png"];
        if (validMimeTypes.includes(file.type)) {
          formik.setFieldValue("avatar", URL.createObjectURL(file));
          formik.setFieldValue("fileAvatar", file);
        } else {
          console.error("Formato inválido. Debe ser JPG o PNG.");
        }
      }
    },
    [formik]
  );
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/jpeg": [".jpeg", ".jpg"], "image/png": [".png"] },
    onDrop,
    multiple: false,
  });

  // Helper para mostrar avatar
  const getAvatar = () => {
    if (formik.values.fileAvatar) return formik.values.avatar;
    if (formik.values.avatar) return `${formik.values.avatar}`;
    return image.noAvatar;
  };

  return (
    <>
      <ToastContainer />

      {loading && (
        <Dimmer active inverted page>
          <Loader content="Cargando..." />
        </Dimmer>
      )}

      <Form onSubmit={formik.handleSubmit}>
        {!verificationSent && (
          <>
            <div className="user-form__avatar" {...getRootProps()}>
              <input {...getInputProps()} />
              <Image avatar size="small" src={getAvatar()} />
            </div>

            <Form.Input
              name="firstname"
              type="text"
              placeholder="Nombre"
              onChange={formik.handleChange}
              value={formik.values.firstname}
              error={
                formik.errors.firstname
                  ? { content: formik.errors.firstname }
                  : null
              }
            />
            <Form.Input
              name="lastname"
              type="text"
              placeholder="Apellido"
              onChange={formik.handleChange}
              value={formik.values.lastname}
              error={
                formik.errors.lastname
                  ? { content: formik.errors.lastname }
                  : null
              }
            />
            <Form.Dropdown
              name="country"
              placeholder="Selecciona un país"
              fluid
              selection
              options={countries}
              onChange={(e, data) =>
                formik.setFieldValue("country", data.value)
              }
              value={formik.values.country}
              error={
                formik.errors.country
                  ? { content: formik.errors.country }
                  : null
              }
            />
            <Form.Dropdown
              name="role"
              placeholder="Selecciona un tipo de cuenta"
              fluid
              selection
              options={[
                { key: "partner", value: "partner", text: "Cuenta Partner" }
              ]}
              onChange={(e, data) => formik.setFieldValue("role", data.value)}
              value={formik.values.role}
              error={
                formik.errors.role ? { content: formik.errors.role } : null
              }
            />
            {formik.values.role === "partner" && (
              <Form.Input
                name="holded"
                type="text"
                placeholder="(Opcional) ID Holded. Consultar con Educa360"
                onChange={formik.handleChange}
                value={formik.values.holded}
                error={
                  formik.errors.holded
                    ? { content: formik.errors.holded }
                    : null
                }
              />
            )}
            <Form.Input
              name="email"
              type="text"
              placeholder="Correo electrónico"
              onChange={formik.handleChange}
              value={formik.values.email}
              error={
                formik.errors.email
                  ? { content: formik.errors.email }
                  : null
              }
            />
            <Form.Input
              name="password"
              type="password"
              placeholder="Contraseña"
              onChange={formik.handleChange}
              value={formik.values.password}
              error={
                formik.errors.password
                  ? { content: formik.errors.password }
                  : null
              }
            />
            <Form.Input
              name="repeatPassword"
              type="password"
              placeholder="Repetir contraseña"
              onChange={formik.handleChange}
              value={formik.values.repeatPassword}
              error={
                formik.errors.repeatPassword
                  ? { content: formik.errors.repeatPassword }
                  : null
              }
            />
            <Form.Checkbox
              name="conditionsAccepted"
              label="Acepto los términos y condiciones"
              onChange={(e, data) =>
                formik.setFieldValue("conditionsAccepted", data.checked)
              }
              checked={formik.values.conditionsAccepted}
              error={
                formik.errors.conditionsAccepted
                  ? { content: formik.errors.conditionsAccepted }
                  : null
              }
            />

            <Button
              type="submit"
              primary
              fluid
              loading={formik.isSubmitting}
            >
              Crear cuenta
            </Button>
          </>
        )}

        {verificationSent && (
          <>
            <p>Ingresa el código que recibiste por e-mail</p>
            <Form.Input
              name="code"
              type="text"
              placeholder="Código de 6 dígitos"
              onChange={formik.handleChange}
              value={formik.values.code}
              error={
                formik.errors.code ? { content: formik.errors.code } : null
              }
            />
            <Button
              type="submit"
              primary
              fluid
              loading={formik.isSubmitting}
            >
              Confirmar cuenta
            </Button>
          </>
        )}
      </Form>
    </>
  );
}
